import { Flex } from "@chakra-ui/react";
import ScheduleCalendar from "../schedule-calendar/ScheduleCalendar";
import { useTranslation } from "react-i18next";
import { useCourseManagementContext } from "@root/context/course-management-context";
import { useEffect, useRef } from "react";
import { useParams } from "react-router-dom";

const Schedule = () => {
  const { startDate, setStartDate, endDate, setEndDate, courseData } =
    useCourseManagementContext();
  const { t } = useTranslation("common");
  const { id } = useParams();
  // Track if dates have been initialized from courseData to prevent re-initialization
  const datesInitializedRef = useRef(false);

  useEffect(() => {
    // Only initialize dates once when courseData is first loaded, and only if dates aren't already set
    if (courseData && id && !courseData?.enrollmentDuration && !datesInitializedRef.current) {
      if (
        courseData?.enrollmentPeriodStart &&
        courseData?.enrollmentPeriodEnd
      ) {
        // Only set dates if they're not already set (to allow user edits)
        if (!startDate || !endDate) {
          try {
            // Convert string dates to Date objects
            const startDateObj = new Date(courseData?.enrollmentPeriodStart);
            const endDateObj = new Date(courseData?.enrollmentPeriodEnd);

            // Verify the dates are valid before setting them
            if (!isNaN(startDateObj.getTime())) {
              setStartDate(startDateObj);
            }
            if (!isNaN(endDateObj.getTime())) {
              setEndDate(endDateObj);
            }
            datesInitializedRef.current = true;
          } catch (error) {
            console.error("Error parsing dates:", error);
            // Only set default dates if parsing fails and dates aren't already set
            if (!startDate || !endDate) {
              setStartDate(new Date());
              setEndDate(new Date());
              datesInitializedRef.current = true;
            }
          }
        } else {
          datesInitializedRef.current = true;
        }
      } else if (!startDate || !endDate) {
        // Initialize with default dates if none exist (only for new courses)
        setStartDate(new Date());
        setEndDate(new Date());
        datesInitializedRef.current = true;
      }
    } else if (!id) {
      // Reset the ref when not in edit mode
      datesInitializedRef.current = false;
    }
  }, [id, courseData, setStartDate, setEndDate, startDate, endDate]);

  return (
    <Flex display={"flex"} gap={"16px"}>
      <ScheduleCalendar
        title={t("setPreferance.startDate")}
        selectedDate={startDate}
        setSelectedDate={setStartDate}
      />
      <ScheduleCalendar
        title={t("setPreferance.endDate")}
        selectedDate={endDate}
        setSelectedDate={setEndDate}
        minDate={startDate}
      />
    </Flex>
  );
};

export default Schedule;
